<div>
  <div class="app__itemCard w-full h-auto justify-start p-0 text-base">
    <div class="flex justify-between items-center p-4 border-b">
      <p class="app__text-higlight flex text-[#1E1E20] text-base m-0 font-semibold">
        {{ data?.title || 'Select Entity To Sync With' }}
      </p>
      <span class="material-icons search-icon text-k-black font-bold cursor-pointer text-base" (click)="closeDialog()"> close </span>
    </div>

    <div class="p-4 relative">
      <div
        [class]="
          entities.length < 1
            ? 'search-wrapper p-3 rounded-lg border border-border-gray shadow-sm flex justify-between items-center'
            : 'search-wrapper p-3 rounded-lg border border-border-gray shadow-sm flex justify-between items-center rounded-b-none'
        "
      >
        <span class="material-icons search-icon text-k-blue text-base cursor-pointer"> search </span>
        <input
          type="text"
          [placeholder]="data?.placeholderText || 'Search Entities'"
          class="w-full border-none outline-none text-[#53565B66]"
          [value]="searchInput.value"
          (input)="handleEntitySearch($event.target.value)"
          (keydown.enter)="onSearchFocus()"
        />
      </div>

      @if (entities.length > 0 && searchInput.value && hasLoadedEntities) {
      <div class="search-results-dropdown border border-t-0 border-border-gray rounded-b-lg shadow-sm max-h-[300px] overflow-y-auto">
        @for (entity of entities; track trackByEntity($index, entity)) {
        <div
          class="flex items-center gap-2 hover:bg-[#EBF0FA] cursor-pointer p-4 border-b last:border-b-0"
          (click)="selectEntity(entity)"
        >
          <div class="w-8 h-8 rounded-full bg-[#EBF0FA] flex items-center justify-center text-[#25508E]">
            <span class="material-icons text-base">domain</span>
          </div>
          <div class="flex items-start flex-col">
            <p class="m-0 font-semibold text-xs">{{ getEntityTitle(entity) }}</p>
            <span class="text-[#898F9E] text-[10px] font-medium"> {{ getEntitySubtitle(entity) }} </span>
          </div>
        </div>
        }
      </div>
      }

      @if (!isLoading && entities.length == 0 && searchInput.value && hasLoadedEntities) {
      <div class="flex gap-3 items-center p-4 border border-t-0 border-border-gray rounded-b-lg">
        <p class="m-0 text-k-blue">No Entity Found</p>
      </div>
      }

      @if (isLoading) {
      <div class="h-full w-full loader-option overflow-hidden border border-t-0 border-border-gray rounded-b-lg">
        <div class="search-box-container w-full">
          <div class="loader-container grid grid-cols-1 p-0">
            @for (item of ['1', '2', '3']; track item) {
            <div class="w-full h-[70px]">
              <div class="ph-item w-full content__loader h-full" style="padding: 0px; margin: 0px; border: none">
                <div class="ph-col-12 h-full" style="padding: 0px !important; margin: 0px">
                  <div class="ph-row h-full">
                    <div class="ph-col-12 h-[90%]"></div>
                  </div>
                </div>
              </div>
            </div>
            }
          </div>
        </div>
      </div>
      }

      @if (!isLoading && !searchInput.value && selectedEntity) {
      <div class="mt-4">
        <div class="flex items-center justify-between gap-2 rounded-lg px-4 py-3 border border-[#D3DCE8] bg-white">
          <div class="flex gap-3 items-center">
            <div class="w-10 h-10 rounded-full bg-[#EBF0FA] flex items-center justify-center text-[#25508E]">
              <span class="material-icons text-base">domain</span>
            </div>
            <div class="flex items-start flex-col">
              <p class="m-0 font-semibold text-sm">{{ getEntityTitle(selectedEntity) }}</p>
              <span class="text-[#898F9E] text-xs font-medium"> {{ getEntitySubtitle(selectedEntity) || 'Entity' }} </span>
            </div>
          </div>
          <button class="flex items-center justify-center rounded-full w-[32px] h-[32px] bg-[#EBF0FA]" (click)="clearEntity()">
            <span class="material-icons text-[#25508E] text-base">remove_circle_outline</span>
          </button>
        </div>
      </div>
      }

      @if (!isLoading && !searchInput.value && !selectedEntity) {
      <div class="mt-4">
        <div class="flex items-center justify-center gap-3 rounded-lg px-4 py-3 border border-[#D3DCE8] bg-[#F9FAFB]">
          <div class="flex items-center justify-center w-[24px] h-[24px]">
            <span class="material-icons text-[#25508E] text-base">domain</span>
          </div>
          <div class="flex items-start flex-col">
            <p class="m-0 font-[600] text-[12px] text-[#1E1E20]">No <span class="text-[#25508E] text-[12px] font-bold">Entity</span> Selected</p>
          </div>
        </div>
      </div>
      }
    </div>

    <hr class="m-0" />
    <div class="flex items-center gap-2 text-base justify-end px-4 py-3">
      <button
        [class]="selectedEntity ? 'app__btn--primary w-fit m-0 mt-0 px-6' : 'app__btn--disabled w-fit m-0 mt-0 px-6'"
        [disabled]="!selectedEntity"
        (click)="confirmSelection()"
      >
        Save
      </button>
    </div>
  </div>
</div>

